const auth = {
    state: {
        authId: "",
    },
    mutations: {
        setAuthId (state, payload) {
            state.authId = payload;
        }
    }
}

export default auth
